import {authRequest, request} from './request';
import {CompanyId, Email, InviteUser} from '../../Config/dataModel';

const allCompanies = () => {
    return request({
        url: '/public/allCompanies',
        method: 'GET'
    });
};

const allInsurers = () => {
    return request({
        url: '/public/allInsurers',
        method: 'GET'
    });
};

const allUserInsurers = () => {
    return authRequest({
        url: '/userInfo/insurer/all',
        method: 'GET'
    });
};

const allUserSubagents = () => {
    return authRequest({
        url: '/userInfo/subagent/all',
        method: 'GET'
    });
};

const registeredInsurers = () => {
    return authRequest({
        url: '/userInfo/insurer/registered',
        method: 'GET'
    });
};

const registeredSubagents = () => {
    return authRequest({
        url: '/userInfo/subagent/registered',
        method: 'GET'
    });
};

const insurerHistory = () => {
    return authRequest({
        url: '/userInfo/insurer/history',
        method: 'GET'
    });
};

const subagentHistory = () => {
    return authRequest({
        url: '/userInfo/subagent/history',
        method: 'GET'
    });
};

const addSubagent = (data: CompanyId) => {
    return authRequest({
        url: '/insurerAdmin/addSubAgent',
        method: 'PUT',
        params: data
    });
};

const deactivateSubagent = (data: CompanyId) => {
    return authRequest({
        url: '/insurerAdmin/removeSubAgent',
        method: 'PUT',
        params: data
    });
};

const allNormalUsers = () => {
    return authRequest({
        url: '/admin/users/allHumans',
        method: 'GET'
    });
};

const allApiUsers = () => {
    return authRequest({
        url: '/admin/users/allRobots',
        method: 'GET'
    });
};

const inviteUser = (data: InviteUser) => {
    return authRequest({
        url: '/admin/inviteUser',
        method: 'PUT',
        data
    });
};

const enableUser = (data: Email) => {
    return authRequest({
        url: '/admin/enableUser',
        method: 'PUT',
        params: data
    });
};

const reinviteUser = (data: Email) => {
    return authRequest({
        url: '/admin/reinvite',
        method: 'PUT',
        params: data
    });
};

const recallInvitation = (data: Email) => {
    return authRequest({
        url: '/admin/recallInvitation',
        method: 'PUT',
        params: data
    });
};

const deactivateUser = (data: Email) => {
    return authRequest({
        url: '/admin/disableUser',
        method: 'PUT',
        params: data
    });
};

const grantAdminRight = (data: Email) => {
    return authRequest({
        url: '/admin/grantAdmin',
        method: 'PUT',
        params: data
    });
};

const removeAdminRight = (data: Email) => {
    return authRequest({
        url: '/admin/removeAdmin',
        method: 'PUT',
        params: data
    });
};

const insurerCount = () => {
    return authRequest({
        url: '/userInfo/insurer/history/count',
        method: 'GET'
    });
};

const subagentCount = () => {
    return authRequest({
        url: '/userInfo/subagent/history/count',
        method: 'GET'
    });
};

const normalUserCount = () => {
    return authRequest({
        url: '/admin/users/allHumans/count',
        method: 'GET'
    });
};

const apiUserCount = () => {
    return authRequest({
        url: '/admin/users/allRobots/count',
        method: 'GET'
    });
};

const userManagementAPI = {
    allCompanies,
    allInsurers,
    allUserInsurers,
    allUserSubagents,
    registeredInsurers,
    registeredSubagents,
    insurerHistory,
    subagentHistory,
    addSubagent,
    deactivateSubagent,
    allNormalUsers,
    allApiUsers,
    inviteUser,
    enableUser,
    reinviteUser,
    recallInvitation,
    deactivateUser,
    grantAdminRight,
    removeAdminRight,
    insurerCount,
    subagentCount,
    normalUserCount,
    apiUserCount
};

export default userManagementAPI



// WEBPACK FOOTER //
// ./src/ReduxRequests/APIs/userManagementAPI.ts